import { captureError } from './captureError';

export const reportThirdPartyScriptError = (
  serviceName: string,
  src: string,
  error?: unknown,
): void => {
  const message = `[3rdParty:${serviceName}] Script failed to load`;
  console.error(message, src, error);

  try {
    captureError(new Error(message), {
      service: serviceName,
      scriptSrc: src,
      originalError: error instanceof Error ? error.message : String(error ?? 'unknown'),
    });
  } catch {
  }
};
